/*
 * @Date: 2023-10-08 14:28:36
 * @Description: CPTPP主题库，包含 数据 + 监测 + 报告
 */
import Layout from "@/layout";
import { cptppRef } from "../utils/reflection";
export default [
  {
    path: "/cptpp",
    redirect: "/cptpp/home",
  },
  {
    path: "/cptpp/data",
    component: Layout,
    redirect: "/cptpp/data/goods",
    name: "data",
    meta: {
      title: "数据",
      icon: "iconfont iconshuju1",
      theme: "cptpp",
    },
    children: [
      {
        path: "goods",
        name: "goodsTrade",
        redirect: "/cptpp/data/goods/world",

        component: () => import("@/views/data/goods/common-theme"),
        meta: { title: "货物贸易" },
        children: [
          {
            path: "world",
            redirect: "/cptpp/data/goods/world/monthly",
            component: () => import("@/views/data/goods/common-theme"),
            name: "world",
            newpath: "/data/goods/world/detail",
            meta: { title: "世界", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["世界月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["世界年度"],
              },
            ],
          },
          // {
          //   path: "asean",
          //   redirect: "/cptpp/data/goods/asean/monthly",
          //   component: () => import("@/views/data/goods/common-theme"),
          //   name: "asean",
          //   newpath: "/data/goods/asean/detail",
          //   meta: { title: "东盟", icon: "iconshuju2 2-1" },
          //   children: [
          //     {
          //       path: "monthly",
          //       component: () =>
          //         import("@/views/data/goods/common-theme/CommonTheme"),
          //       name: "monthly",
          //       meta: cptppRef["东盟季度"],
          //     },
          //     {
          //       path: "annual",
          //       component: () =>
          //         import("@/views/data/goods/common-theme/CommonTheme"),
          //       name: "annual",
          //       meta: cptppRef["东盟年度"],
          //     },
          //   ],
          // },
          {
            path: "japan",
            redirect: "/cptpp/data/goods/japan/monthly",
            component: () => import("@/views/data/goods/common-theme"),
            name: "japan",
            newpath: "/data/goods/asia/japan/detail",
            meta: { title: "日本", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["日本月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["日本年度"],
              },
            ],
          },
          {
            path: "malaysia",
            redirect: "/cptpp/data/goods/malaysia/monthly",
            newpath: "/data/goods/asia/malaysia/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "malaysia",
            meta: { title: "马来西亚", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["马来西亚月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["马来西亚年度"],
              },
            ],
          },

          {
            path: "brunei",
            redirect: "/cptpp/data/goods/brunei/monthly",
            newpath: "/data/goods/brunei/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "brunei",
            meta: { title: "文莱", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["文莱季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["文莱年度"],
              },
            ],
          },
          {
            path: "singapore",
            redirect: "/cptpp/data/goods/singapore/monthly",
            newpath: "/data/goods/singapore/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "singapore",
            meta: { title: "新加坡", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["新加坡季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["新加坡年度"],
              },
            ],
          },
          {
            path: "vietnam",
            redirect: "/cptpp/data/goods/vietnam/monthly",
            newpath: "/data/goods/vietnam/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "vietnam",
            meta: { title: "越南", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["越南季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["越南年度"],
              },
            ],
          },
          {
            path: "mexcico",
            redirect: "/cptpp/data/goods/mexcico/monthly",
            newpath: "/data/goods/mexcico/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "mexcico",
            meta: { title: "墨西哥", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["墨西哥月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["墨西哥年度"],
              },
            ],
          },

          {
            path: "jnd",
            redirect: "/cptpp/data/goods/jnd/monthlyjc",
            newpath: "/data/goods/bmz/jnd/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "jnd",
            meta: { title: "加拿大", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthlyjc",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthlyjc",
                meta: cptppRef["加拿大本地出口月度"],
              },
              {
                path: "monthlyj",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthlyj",
                meta: cptppRef["加拿大进口月度"],
              },
              {
                path: "monthlyc",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthlyc",
                meta: cptppRef["加拿大总出口月度"],
              },
            ],
          },
          {
            path: "zhili",
            redirect: "/cptpp/data/goods/zhili/monthly",
            component: () => import("@/views/data/goods/common-theme"),
            name: "zhili",
            newpath: "/data/goods/nmz/zhili/detail",
            meta: { title: "智利", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["智利月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["智利年度"],
              },
            ],
          },
          {
            path: "bilu",
            redirect: "/cptpp/data/goods/bilu/monthly",
            component: () => import("@/views/data/goods/common-theme"),
            name: "bilu",
            newpath: "/data/goods/nmz/bilu/detail",
            meta: { title: "秘鲁", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["秘鲁月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["秘鲁年度"],
              },
            ],
          },
          {
            path: "xxl",
            redirect: "/cptpp/data/goods/xxl/monthly",
            newpath: "/data/goods/dyz/xxl/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "xxl",
            meta: { title: "新西兰", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["新西兰月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["新西兰年度"],
              },
            ],
          },
          {
            path: "australia",
            redirect: "/cptpp/data/goods/australia/monthly",
            newpath: "/data/goods/australia/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "australia",
            meta: { title: "澳大利亚", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["澳大利亚月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["澳大利亚年度"],
              },
            ],
          },
          {
            path: "UK",
            redirect: "/cptpp/data/goods/UK/monthly",
            newpath: "/data/goods/UK/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "australia",
            meta: { title: "英国", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: cptppRef["英国月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: cptppRef["英国年度"],
              },
            ],
          },
        ],
      },
    ],
  },
];
